export default __webpack_public_path__ + "static/media/pattern-login-lg.4085e9aa.svg";